import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f750160c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = { class: "dialog-footer" }

import { ref, onMounted, watch } from "vue";
import { Parameter } from "@/types/parameter.type";
import { Filter } from "@/types/filter.type";
import { ValidationFilter } from "@/types/estimation.type";
import { Estimation } from "@/types/estimation.type";
import Mae from "@/components/information/metrics/Mae.component.vue";
import Mape from "@/components/information/metrics/Mape.component.vue";
import { getAverageEstimations } from "@/service/estimation.service";
import { getParameter } from "@/service/parameter.service";
import { getImportResult, getResult, getPaginatedEstimations } from "@/service/estimation.service";

import { useRoute } from "vue-router";

import { useI18n } from "vue-i18n";
import { i18n } from "@/plugins/i18n.plugin";


export default /*#__PURE__*/_defineComponent({
  props: {
    dataClient: null,
    parameterImport: null,
    nameParameter: null,
    selectedValue: null,
    csvContent: null,
    selectedTimeFrom: null,
    selectedTimeTo: null
  },
  setup(__props: any) {

const props = __props as {
  dataClient: Array<{ date: string; value: string }>;
  parameterImport: Parameter;
  nameParameter: string;
  selectedValue: string;
  csvContent: string;
  selectedTimeFrom: string;
  selectedTimeTo: string;
}

const { t } = useI18n();
const route = useRoute();

const metricTable = ref([
  {
    metric: "Número de estimaciones de Aquacorp",
    result: undefined,
    description: "Conteo del número de datos que hay como estimaciones",
  },
  {
    metric: "Número de datos de referencia del laboratorio",
    result: undefined,
    description: "Conteo del número de datos que hay como datos importados",
  },
  {
    metric: "MAE",
    result: undefined,
    description: "Valor del error absoluto medio entre las estimaciones y los datos importados",
  },
  {
    metric: "MAPE",
    result: undefined,
    description:
      "Valor del error absoluto medio porcentual entre las estimaciones y los datos importados",
  },
] as Array<{ metric: string; result: number | undefined; description: string }>);

const isDialogVisibleMAE = ref(false);
const isDialogVisibleMAPE = ref(false);
const dialog = ref<string>();


const showDialog = (metric: string) => {
  dialog.value = metric;
  isDialogVisibleMAE.value = metric === "MAE" ? true : false;
  isDialogVisibleMAPE.value = metric === "MAPE" ? true : false;
};

const calculateResult = async () => {
  const filter: Filter = {
    fields: {
      "parameter.name": {
        operator: "equal",
        value: props.nameParameter.replace("\r", ""),
      },
    },
  };
  const parameter = (await getParameter(undefined, undefined, filter))?.data;
  const validationFilter = {
    samplingPointId: [Number(route.params.samplingPoint)],
    parameterId: [parameter[0]?.id],
    //date: [fromDate, toDate],
    date: [
      parseDateString(props.dataClient[0].date),
      parseDateString(props.dataClient[props.dataClient.length - 1].date),
    ],
  } as ValidationFilter;

  let estimation_history: Estimation[] = [] as unknown as Estimation;

  estimation_history = await getPaginatedEstimations(validationFilter);
  let metric;
  const cleanedData = props.dataClient.map((item) => ({
    date: item.date,
    value: item.value.replace("\r", "").replace(",", "."),
  }));

  if (props.selectedValue == "Muestras integradas") {
    estimation_history = await getAverageEstimations(
      validationFilter,
      formatTime(props.selectedTimeFrom),
      formatTime(props.selectedTimeTo)
    );
    metric = await getImportResult(validationFilter, cleanedData, estimation_history);
    metric.numEstimation = estimation_history.length;
  } else {
    const dataValidation = props.dataClient.map((item) => ({
      dateTime: parseDateString(item.date),
      value: item.value.replace("\r", "").replace(",", "."),
      magnitude: parameter[0]?.name,
      parameter: parameter[0],
      unit: "",
      origin: "",
    }));

    metric = await getResult(validationFilter, dataValidation);
    metric.numEstimation = estimation_history.length;
  }

  return metric;
};

function parseDateString(dateString: string): Date {
  const [datePart, timePart] = dateString.split(" ");
  const [day, month, year] = datePart.split("/").map(Number);

  let hour = 0,
    minute = 0,
    second = 0;

  if (timePart) {
    [hour, minute, second = 0] = timePart.split(":").map(Number);
  }
  return new Date(year, month - 1, day, hour, minute, second);
}

function formatTime(dateString: string): string {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "00:00";
  }

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function formatNumber(value: any) {
  if (!value || !Number(value) || value === "-") {
    return "-";
  } else {
    return i18n.global.n(Number(value), "fixed");
  }
}

watch(
  () => props.nameParameter,
  async () => {
    metricTable.value[1].result = props.dataClient.length;
    const metric = await calculateResult();
    metricTable.value[0].result = metric.numEstimation;
    metricTable.value[2].result = metric.mae;
    metricTable.value[3].result = metric.mape;
  }
);

onMounted(async () => {
  metricTable.value[1].result = props.dataClient.length;
  const metric = await calculateResult();
  metricTable.value[0].result = metric.numEstimation;
  metricTable.value[2].result = metric.mae;
  metricTable.value[3].result = metric.mape;
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_table, {
      data: metricTable.value,
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "metric",
          label: _unref(t)('label.statisticalMetric'),
          width: "350"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.metric) + " ", 1),
            (scope.row.metric === 'MAE' || scope.row.metric === 'MAPE')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "info",
                  size: "small",
                  onClick: ($event: any) => (showDialog(scope.row.metric)),
                  circle: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "result",
          label: _unref(t)('label.result'),
          width: "150",
          align: "center",
          "header-align": "center"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(formatNumber(scope.row.result)) + " " + _toDisplayString(scope.row.metric === "MAPE" ? "%" : ""), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "description",
          label: _unref(t)('label.description')
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: isDialogVisibleMAE.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isDialogVisibleMAE).value = $event)),
      title: 'Información del MAE',
      "custom-class": "app-form",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isDialogVisibleMAE.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("btn.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(Mae)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isDialogVisibleMAPE.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isDialogVisibleMAPE).value = $event)),
      title: 'Información del MAPE',
      "custom-class": "app-form",
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isDialogVisibleMAPE.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("btn.close")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(Mape)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})